import { Typography } from '@mui/material';
import type { TypographyProps } from '@mui/material';

export const LabelCaps: React.FC<TypographyProps> = ({ children, sx, ...rest }) => (
  <Typography
    component="div"
    sx={{
      fontSize: 12,
      fontWeight: 600,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: 'text.secondary',
      ...sx,
    }}
    {...rest}
  >
    {children}
  </Typography>
);
